// extracted by mini-css-extract-plugin
module.exports = {"Order":"order_Order__2y9aR","logo":"order_logo__38ET3","status":"order_status__3EwsX","item":"order_item__bqXfr","OrderMobile":"order_OrderMobile__1bIdd"};